export function disableContactLinks() {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (!isMobile) {
    const phones = document.querySelectorAll('.js-click-phone');
    const emails = document.querySelectorAll('.js-click-email');

    phones.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });

    emails.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const email = link.textContent.trim();

        if (navigator.clipboard) {
          navigator.clipboard.writeText(email).then(() => {
            showCopyToast('Email скопирован');
          }).catch(err => {
            console.warn('Не удалось скопировать email:', err);
          });
        }
      });
    });
  }
}

function showCopyToast(message = 'Скопировано') {
  const toast = document.getElementById('copy-toast');
  if (!toast) return;

  toast.textContent = message;
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
  }, 2000);
}
